import { useQuery } from '@tanstack/react-query';
import api from '../utils/api';

const DAY_MS = 86_400_000;

function toISO(d) {
  return d.toISOString().slice(0, 10);
}

// The sidebar wants the user's entire journal history in a single call so
// search and the calendar work across every year. We fetch a very wide window
// by default (~10 years) — the backend caps at ~20 years. Callers can still
// pass an explicit { from, to } to narrow it.
export function useJournalIndex(userId, { from, to, windowDays = 3650 } = {}) {
  const resolvedTo = to || toISO(new Date());
  const resolvedFrom = from || toISO(new Date(Date.parse(resolvedTo) - windowDays * DAY_MS));

  return useQuery({
    queryKey: ['journal-index', userId, resolvedFrom, resolvedTo],
    enabled: !!userId,
    queryFn: async () => {
      const res = await api.get(`/user/${userId}/journal/index`, {
        params: { from: resolvedFrom, to: resolvedTo },
      });
      return res.data;
    },
    staleTime: 60_000,
    select: (data) => data?.entries || [],
  });
}
